import { FC } from 'react';

import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import HolidayList from '../../modules/holidays/components/HolidayList';
import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';

const AgentHolidaysPage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'tasks.agentHolidays' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <HolidayList />
        </div>
      </div>
    </>
  );
};

export { AgentHolidaysPage };
